import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';
import {
    FETCH_GDPR_FEATURE,
    FETCH_GDPR_FEATURE_SUCCESS,
    FETCH_GDPR_CONSENT_TEXT,
    FETCH_GDPR_CONSENT_TEXT_SUCCESS,
    FETCH_GDPR_REVOKE_CONSENT,
    FETCH_GDPR_REVOKE_CONSENT_SUCCESS,
    FETCH_GDPR_GRANT_CONSENT,
    FETCH_GDPR_GRANT_CONSENT_SUCCESS,
    FETCH_GDPR_FEATURE_FAIL,
    FETCH_GDPR_CONSENT_TEXT_FAIL,
    FETCH_GDPR_REVOKE_CONSENT_FAIL,
    FETCH_GDPR_GRANT_CONSENT_FAIL,
    POST_GDPR_FEATURE_OPT_IN,
    POST_GDPR_FEATURE_OPT_OUT
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

// worker
export function* fetchGdprFeature(action) {
    try {
        const response = yield call(gcApi.get, `/gdprconsent-service/feature/${action.key}`);

        yield put({
            type: FETCH_GDPR_FEATURE_SUCCESS,
            key: action.key,
            feature: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GDPR_FEATURE_FAIL
        });
    }
}

export function* postGdprFeatureOptin(action) {
    try {
        const response = yield call(gcApi.post, `/gdprconsent-service/feature/optin/${action.key}`);

        yield put({
            type: FETCH_GDPR_FEATURE_SUCCESS,
            key: action.key,
            feature: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GDPR_FEATURE_FAIL
        });
    }
}

export function* postGdprFeatureOptout(action) {
    try {
        const response = yield call(gcApi.post, `/gdprconsent-service/feature/optout/${action.key}`);

        yield put({
            type: FETCH_GDPR_FEATURE_SUCCESS,
            key: action.key,
            feature: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GDPR_FEATURE_FAIL
        });
    }
}

//worker
export function* fetchGdprConsentText(action) {
    try {
        const { key, locale } = action;
        const response = yield call(
            axios.get,
            `/consentTextServices/consentText?consentTypeId=${key}&locale=${locale}`,
            { baseURL: '/' }
        );

        yield put({
            type: FETCH_GDPR_CONSENT_TEXT_SUCCESS,
            key: key,
            consentText: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GDPR_CONSENT_TEXT_FAIL
        });
    }
}

// worker
export function* fetchGdprRevokeConsent(action) {
    try {
        const { key, locale, consentVersion, clientIndicator, passwordChallengeToken, callback } = action;
        let response = null;

        response = yield call(
            gcApi.post,
            `/gdprconsent-service/consent/revoke/${key}/${clientIndicator}`,
            {
                consentTypeId: key,
                clientIndicator: clientIndicator,
                consentLocale: locale,
                consentVersion: consentVersion
            },
            {
                headers: {
                    ...(passwordChallengeToken && { passwordChallengeToken: passwordChallengeToken })
                }
            }
        );

        yield put({
            type: FETCH_GDPR_REVOKE_CONSENT_SUCCESS,
            key: key,
            locale: locale,
            consentVersion: consentVersion,
            revokeConsent: response.data
        });

        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        }
    } catch (e) {
        yield put({
            type: FETCH_GDPR_REVOKE_CONSENT_FAIL
        });

        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, e);
        }
    }
}

// worker
export function* fetchGdprGrantConsent(action) {
    try {
        const { key, locale, consentVersion, featureKey } = action;
        const response = yield call(gcApi.post, `/gdprconsent-service/consent/grant`, {
            consentTypeId: key,
            consentLocale: locale,
            consentVersion: consentVersion
        });

        yield put({
            type: FETCH_GDPR_GRANT_CONSENT_SUCCESS,
            key: key,
            locale: locale,
            consentVersion: consentVersion,
            grantConsent: response.data
        });
        if (featureKey) {
            yield put({
                type: FETCH_GDPR_FEATURE,
                key: featureKey,
                feature: response.data
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_GDPR_GRANT_CONSENT_FAIL
        });
    }
}

// watcher
export const gdprSagas = [
    takeEvery(FETCH_GDPR_FEATURE, fetchGdprFeature),
    takeEvery(FETCH_GDPR_CONSENT_TEXT, fetchGdprConsentText),
    takeEvery(FETCH_GDPR_REVOKE_CONSENT, fetchGdprRevokeConsent),
    takeEvery(FETCH_GDPR_GRANT_CONSENT, fetchGdprGrantConsent),
    takeEvery(POST_GDPR_FEATURE_OPT_IN, postGdprFeatureOptin),
    takeEvery(POST_GDPR_FEATURE_OPT_OUT, postGdprFeatureOptout)
];
